<template>
<div>
    <div class="top-cart-list">
        <h4>
            我的訂單
            <el-button type="text" @click="insertMealBtn()">新增餐點</el-button>
        </h4>
        <template v-if="refreshChoiceList">
            <slip-del v-for="(item,index) in shoppingCartMealChoiceList" :key="'item'+index">
                <Meal toDetail :item="item" :mealData="shoppingCartMealData" :takeoutId="takeoutId" :index="index" @mealResult="mealResult" ref="setMeal"></Meal>
                <div slot="del" @click="[delMealIndex=index,checkDelMeal()]"><img src="@/assets/images/delete_white_line.svg"> </div>
            </slip-del>
        </template>
    </div>
    <div class="shadow-line mr-0 ml-0 mt-0"/>
</div>
</template>
<script>
    import Meal from '@/views/order/components/Meal';
    import SlipDel from 'vue-slip-delete';
    import {notNull} from '@/util/common';
    export default {
        name: "MealList",
        components:{
            Meal, //餐點
            SlipDel,//左滑刪除
        },
        props:{
            fromRoute:{},
            takeoutId:{},
        },
        data() {
            return {
                refreshChoiceList: this.$store.state.cartPageSnapshot.refreshChoiceList,
                shoppingCartMealChoiceList: this.$store.state.cartPageSnapshot.shoppingCartMealChoiceList, //購物車中的餐點資訊
                shoppingCartMealData: this.$store.state.cartPageSnapshot.shoppingCartMealData,       //所有餐點資料
                showDelDialog: this.$store.state.cartPageSnapshot.showDelDialog,   //刪除餐點彈框
                storeId: Number(this.$route.query.storeId?this.$route.query.storeId:this.$store.state.cartStoreId),//店家id(query過來的是修改訂單)
                removeSubscribe:{},
                isCordova: this.$public.isCordova(),
                isOnlineOrder: Boolean(sessionStorage.getItem("isOnlineOrder")),
            }
        },
        created() {
            // this.setupData();
        },
        destroyed() {
          this.removeSubscribe();
        },
        mounted() {
            this.removeSubscribe = this.$store.subscribe((mutation) => {
                if (mutation.type==="updateShoppingCartMealData") {
                    this.shoppingCartMealData = mutation.payload;
                }
                if (mutation.type==="updateShoppingCartMealChoiceList") {
                    this.shoppingCartMealChoiceList = mutation.payload;
                    //重置compoment
                    this.refreshChoiceList = false;
                    this.$nextTick(()=>{
                        this.refreshChoiceList = true;
                        this.$forceUpdate();
                    });
                }
            });
        },
        methods: {
            setupData() {
                let mealChoiceListTable = '';   //sql_ite餐點選擇狀態資料表名稱
                let mealDataTable = '';     //sql_lite參點資料的資料表名稱
                //判斷是否為修改訂單
                if (this.takeoutId !== 0) {
                    mealChoiceListTable = 'order_record_meal_choiceList';
                    mealDataTable = 'order_record_meal_data';
                } else {
                    mealChoiceListTable = 'shopping_cart_meal_choiceList';
                    mealDataTable = 'shopping_cart_meal_data';
                }
                if (notNull(this.fromRoute) && ['OrderCouponList', 'OrderAddressList', 'OrderHelp', 'OINPay', 'PayPassword'].indexOf(this.fromRoute.name) === -1) {  // 撈出餐點資料(1)
                    let callback = (resultSet) => {
                        let length = this.isCordova ? resultSet.rows.length : resultSet.length;

                        for (let index = 0; index < length; index++) {
                            const element = this.isCordova ? resultSet.rows.item(index) : resultSet[index];
                            this.$set(this.shoppingCartMealData, index, element);
                            choiceListCallback()
                        }
                    }

                    if (this.isCordova) {
                        this.$sqlite.query('select * from ' + mealDataTable, [], callback);
                    } else {
                        this.$sqlite.queryDB(mealDataTable, "", "", callback);
                    }
                }
                let choiceListCallback = () => {
                    if (notNull(this.fromRoute) && ['OrderCouponList', 'OrderAddressList', 'OrderHelp', 'OINPay', 'PayPassword'].indexOf(this.fromRoute.name) === -1) {  // 撈出餐點選項資料(2)
                        this.refreshChoiceList = false;
                        this.shoppingCartMealChoiceList = [];

                        let callback = (resultSet) => {
                            let length = this.isCordova ? resultSet.rows.length : resultSet.length;

                            for (let index = 0; index < length; index++) {
                                const element = this.isCordova ? resultSet.rows.item(index) : resultSet[index];
                                this.$set(this.shoppingCartMealChoiceList, index, element);
                            }
                            this.$store.commit("updateShoppingCartMealChoiceList", this.shoppingCartMealChoiceList);
                            this.refreshChoiceList = true;
                        }

                        if (this.isCordova) {
                            this.$sqlite.query('select * from ' + mealChoiceListTable, [], callback);
                        } else {
                            this.$sqlite.queryDB(mealChoiceListTable, "", "", callback);
                        }
                    }
                }
            },
            // Meal回傳數量
            mealResult(index,newVal,oldVal,choicePrice){
                if (newVal===0){
                    this.delMealIndex = index;
                    this.delMealOldVal = oldVal;
                    this.checkDelMeal();
                }else{
                    let nowItem = this.shoppingCartMealChoiceList[index];
                    nowItem.amount = newVal;
                    nowItem.choicePrice = choicePrice;
                }
            },
            // 開啟刪除餐點防呆彈框
            checkDelMeal(){
                if (this.shoppingCartMealChoiceList[this.delMealIndex].isDisableModify) {
                    return this.$public.showNotify('請取消優惠券再刪除', false);
                }

                this.$store.commit("trigerCartDelDialog",{
                    showDelDialog:true,
                    delMealIndex:this.delMealIndex,
                    delMealOldVal:this.delMealOldVal,
                });
            },
            insertMealBtn(){
                if (this.takeoutId) {
                    this.$router.push({name: 'EditOrderList',query:{id:this.storeId,takeoutId:this.takeoutId}});
                } else {
                  if(this.isCordova || this.isOnlineOrder) {
                    this.$router.push({name: 'OrderList', query: {id: this.storeId}});
                  } else {
                    this.$router.push({name:'OrderList'});
                  }
                }
            },
        },
    }
</script>
        